import React from "react";

import { useFormikContext } from "formik";
import { PointOfViewEnum, SourceEnum } from "../../../../../enums/template";
import { Template } from "../../../../../models";
import { getMediaLinkPlaceholder } from "../../../../../utils";
import CustomTextInput from "./CustomTextInput";
import { default as MediaAndAutomationSettings } from "./MediaAndAutomationSettings";
import RankedItemsSetup, {
  bestItemsCountOptions,
  topItemsCountOptions,
} from "./RankedItemsSetup";
import RssFeedUrlsInput from "./RssFeedUrlsInput";
import UploadMediaInput from "./UploadMediaInput";

const SOCIAL_MEDIA_PLATFORMS = [
  SourceEnum.INSTAGRAM_REELS,
  SourceEnum.YOUTUBE_SHORTS,
  SourceEnum.YOUTUBE_VIDEOS,
  SourceEnum.APPLE_PODCASTS,
];

export default function MediaSetup() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();

  if (!values?.sourceId) return null;

  return (
    <div>
      {SOCIAL_MEDIA_PLATFORMS.includes(values.sourceId) && (
        <MediaAndAutomationSettings />
      )}

      {values.sourceId === SourceEnum.RSS_FEEDS && <RssFeedUrlsInput />}
      {values.sourceId === SourceEnum.TEXT_BLOCK && <CustomTextInput />}
      {values.sourceId === SourceEnum.UPLOAD_MEDIA && <UploadMediaInput />}
      {values.sourceId === SourceEnum.TOP_ITEMS && (
        <RankedItemsSetup
          topicFieldName="topItemsTopic"
          countFieldName="topItemsCount"
          topicLabel="Top Items Topic"
          countLabel="How many top items to add?"
          placeholder={getMediaLinkPlaceholder(SourceEnum.TOP_ITEMS)}
          countOptions={topItemsCountOptions}
          defaultCount={10}
        />
      )}
      {values.sourceId === SourceEnum.BEST_ITEMS && (
        <RankedItemsSetup
          topicFieldName="bestItemsTopic"
          countFieldName="bestItemsCount"
          topicLabel="Best Items Topic"
          countLabel="How many best items to add?"
          placeholder={getMediaLinkPlaceholder(SourceEnum.BEST_ITEMS)}
          countOptions={bestItemsCountOptions}
          defaultCount={11}
          onMount={() =>
            setFieldValue("pointOfViewId", PointOfViewEnum.FIRST_PERSON)
          }
        />
      )}
    </div>
  );
}
